var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7458 79.974L62.9417 71.4146L53.6042 67.3511L62.9417 63.2876L66.7458 54.2959L70.6364 63.2876L79.9739 67.3511L70.6364 71.4146L66.7458 79.974Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7458 28.5314L62.9417 19.6262L53.6042 15.4762L62.9417 11.4126L66.7458 2.9397L70.6364 11.4126L79.9739 15.4762L70.6364 19.6262L66.7458 28.5314Z",
    fill: "#171C8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8771 66.8323L20.75 49.3678L2.93958 41.4136L20.75 33.4594L28.8771 16.0813L37.0906 33.4594L54.8146 41.4136L37.0906 49.3678L28.8771 66.8323Z",
    fill: "#0B0F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.0414f365380b6a590c53a26ccd83cfdf.svg";
export { ForwardRef as ReactComponent };